import i18n from "@app/i18n";
import {
  CONST_PREFIX_FROM_JS,
  ECChooserPage,
  EMenuCmdTab,
} from "@app/state/constants";
import { TBlueObj } from "@app/types/insider";

// the tabs will play when we are running in real browser. otherwise the tabs will be delhi buttons in header

const CHOOSER_REPO = "categoryChooser";
const t = i18n.t.bind(i18n);

export type TChooserRepo = {
  id: ECChooserPage;
  name: string;
  parentId: number | null; // Adjusted the type to match the actual values used in categoryChooser
  tabs: EMenuCmdTab[];
};

export const categoryChooser = [
  {
    //entities
    id: ECChooserPage.CONST_CCH_ENTITIES,
    name: t("Entitati"),
    parentId: null,
    tabs: [EMenuCmdTab.CMD_BGIM_CLIENTS],
  },
  {
    //invoices
    id: ECChooserPage.CONST_CCH_INVOICING,
    name: t("Facturare"),
    parentId: null,
    tabs: [
      EMenuCmdTab.CMD_BGIM_INVOICE_OVERALL,
      // , EMenuCmdTab.CMD_BGIM_INVOICE
    ],
  },
  {
    //reports
    id: ECChooserPage.CONST_CCH_REPORTS,
    name: t("Rapoarte"),
    parentId: null,
    tabs: [EMenuCmdTab.CMD_BGIM_REPORTS],
  },
  {
    //settings
    id: ECChooserPage.CONST_CCH_SETTINGS,
    name: t("Setari"),
    parentId: null,
    tabs: [
      EMenuCmdTab.CMD_BGIM_EMITENT,
      EMenuCmdTab.CMD_BGIM_USERCONFIG,
      EMenuCmdTab.CMD_BGIM_INVOICE_SERIES,
      EMenuCmdTab.CMD_BGIM_ACCOUNTS,
    ],
  },
] as TChooserRepo[];

type TRegisteredChooserRepo = typeof categoryChooser;
export type TChooserRepoName = TRegisteredChooserRepo[number]["name"];

export type TDrawerState = {
  currentPage: ECChooserPage;
  currentChild: number;
  //for a more compliant state with the delphi production code, we will set the currentTab from the uiJGBrowserHeader
  // currentTab: EMenuCmdTab;
  items: TRegisteredChooserRepo;
};

export const chooserRepo: TBlueObj<TDrawerState> = {
  name: CHOOSER_REPO,
  initialState: {
    currentPage: null,
    // ECChooserPage.CONST_CCH_INVOICING,
    currentChild: -1,
    items: categoryChooser,
  } as TDrawerState,
  bootPriority: 1,
  starfx: true,
  idb: false,
};
